import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const B = { primary: '#4357AD', dark: '#1E2A4A', orange: '#FF521B' };

const ConfirmDialog = ({ open, title, description, onCancel, onConfirm, confirmText = 'Підтвердити' }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 4,
        border: `2px solid ${B.primary}`,
        boxShadow: '0 20px 60px rgba(67, 87, 173, 0.18)',
        overflow: 'hidden',
      },
    }}
  >
    <Box
      sx={{
        background: `linear-gradient(135deg, ${B.dark} 0%, ${B.primary} 100%)`,
        px: 3,
        py: 2.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <WarningAmberRoundedIcon sx={{ color: '#FEF3C7', fontSize: 22 }} />
      </Box>
      <DialogTitle
        sx={{
          p: 0,
          color: '#fff',
          fontWeight: 700,
          fontSize: '1.15rem',
          lineHeight: 1.3,
        }}
      >
        {title}
      </DialogTitle>
    </Box>

    <DialogContent sx={{ px: 3, pt: 3, pb: 1.5 }}>
      <DialogContentText
        sx={{
          color: '#475569',
          fontSize: '0.95rem',
          lineHeight: 1.6,
        }}
      >
        {description}
      </DialogContentText>
    </DialogContent>

    <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1.5 }}>
      <Button
        onClick={onCancel}
        sx={{
          borderRadius: 3,
          textTransform: 'none',
          fontWeight: 600,
          color: '#64748B',
          px: 3,
          '&:hover': {
            bgcolor: '#F1F5F9',
          },
        }}
      >
        Скасувати
      </Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        sx={{
          borderRadius: 3,
          textTransform: 'none',
          fontWeight: 700,
          px: 3,
          bgcolor: B.orange,
          boxShadow: '0 4px 14px rgba(255, 82, 27, 0.3)',
          '&:hover': {
            bgcolor: '#E5461A',
            boxShadow: '0 6px 20px rgba(255, 82, 27, 0.4)',
          },
        }}
      >
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
